"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomePageMainSlider = void 0;
const react_1 = __importDefault(require("react"));
const swiper_1 = __importStar(require("swiper"));
const react_2 = require("swiper/react");
const HomePageMainSliderLabel_1 = require("./HomePageMainSliderLabel");
require("swiper/swiper-bundle.css");
require("./index.scss");
const className = 'HomePageMainSlider';
swiper_1.default.use([swiper_1.Navigation, swiper_1.Pagination, swiper_1.Autoplay, swiper_1.Lazy]);
const HomePageSwiper = (props) => {
    const { items, delay } = props;
    if (items.length === 0) {
        return (react_1.default.createElement("div", { style: {
                backgroundColor: 'lightgray',
                width: '100%',
                height: '650px',
            } }));
    }
    return (react_1.default.createElement(react_2.Swiper, { autoplay: { delay: delay !== null && delay !== void 0 ? delay : 2000 }, loop: true, slidesPerView: 1, pagination: true, navigation: true, autoHeight: true, lazy: true, preloadImages: false }, items.map((item, idx) => (react_1.default.createElement(react_2.SwiperSlide, { key: idx },
        react_1.default.createElement("div", { className: 'HomePageMainSlider__slide', onClick: item.onClick },
            react_1.default.createElement("img", { className: 'HomePageMainSlider__image', src: item.image, alt: 'main image' }),
            item.flightLabel && (react_1.default.createElement(HomePageMainSliderLabel_1.HomePageMainSliderLabel, { classNames: 'HomePageMainSlider__label', data: item.flightLabel }))))))));
};
const HomePageMainSlider = (props) => {
    const { items, delay, children } = props;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(HomePageSwiper, { items: items, delay: delay }),
        react_1.default.createElement("div", { className: 'HomePageMainSlider__search-form' }, children)));
};
exports.HomePageMainSlider = HomePageMainSlider;
//# sourceMappingURL=index.js.map